import { render, staticRenderFns } from "./singleChoice.vue?vue&type=template&id=178b8a8e&scoped=true"
import script from "./singleChoice.vue?vue&type=script&lang=js"
export * from "./singleChoice.vue?vue&type=script&lang=js"
import style0 from "./singleChoice.vue?vue&type=style&index=0&id=178b8a8e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178b8a8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('178b8a8e')) {
      api.createRecord('178b8a8e', component.options)
    } else {
      api.reload('178b8a8e', component.options)
    }
    module.hot.accept("./singleChoice.vue?vue&type=template&id=178b8a8e&scoped=true", function () {
      api.rerender('178b8a8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/questionnaire/customerManage/questionnaireList/components/singleChoice.vue"
export default component.exports